// The week 1 this phone keeps (src/plan/WeekPage.tsx), read without loading the page itself, so Home stays light.
import { WEEK_ONE_KEY, type WeekOne } from '../../shared/weekOne';

/** The week this phone keeps, or null. */
export function savedWeek(): WeekOne | null {
  try {
    const raw = localStorage.getItem(WEEK_ONE_KEY);
    const week = raw ? (JSON.parse(raw) as WeekOne) : null;
    return week?.days?.length === 7 ? week : null;
  } catch { return null; }
}

/** The library's Excluded exercises now (server /api/exercises/excluded); an empty set when it can't be read. */
export async function excludedNow(): Promise<Set<string>> {
  try {
    const r = await fetch('/api/exercises/excluded');
    const b = r.ok ? ((await r.json()) as { ids?: unknown }) : null;
    return new Set(Array.isArray(b?.ids) ? b.ids.filter((x): x is string => typeof x === 'string') : []);
  } catch { return new Set(); }
}
